import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SearchPartRow = ({ part, onClick, isInvoiceMode }) => {
  const theme = useTheme();
  const finalPrice =
    part.finalPrice ||
    part.groupAdjustedPrice ||
    parseFloat(part["PRICE"] || 0);

  const formatPrice = (price) => {
    // Round to the nearest dollar
    return Math.round(parseFloat(price));
  };

  // Check if price was adjusted from the original price
  const originalPrice = part.adjustedPrice ? part.adjustedPrice : part["PRICE"];
  const hasAdjustedPrice = originalPrice !== finalPrice;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 12px",
        margin: "4px 0",
        backgroundColor: "#000000",
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "4px",
        cursor: !isInvoiceMode ? "pointer" : "default",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.05)", // Very subtle white overlay instead of text color
          borderColor: theme.palette.primary.main,
          transform: "translateY(-1px)",
        },
      }}
      onClick={() => !isInvoiceMode && onClick(part)}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            color: theme.palette.text.primary,
            fontSize: "0.9rem",
            marginBottom: "2px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {part["PART NUMBER"]}
        </Typography>
        {part["DESCRIPTION"] && (
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              fontSize: "0.75rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {part["DESCRIPTION"]}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          marginLeft: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            color: theme.palette.primary.main,
            fontSize: "0.9rem",
            minWidth: "fit-content",
          }}
        >
          ${formatPrice(finalPrice)}
        </Typography>

        {isInvoiceMode && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClick(part, 1);
              }}
              sx={{
                minWidth: "60px",
                fontSize: "0.75rem",
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              Add 1
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClick(part, 0.5);
              }}
              sx={{
                minWidth: "70px",
                fontSize: "0.75rem",
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                "&:hover": {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
              }}
            >
              Add 0.5
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SearchPartRow;
